<template>
	<div
		class="top-line	"
	>
		<div
			v-if="is_on"
			class="mt-30 width-720-pc pa-10 justify-space-between-pc ma-auto box bg-eee"
		>
			<div class="flex-2 size-px-14 flex-column justify-center color-black font-weight-bold ">
				1. 구글 스토어 또는 앱 스토어에서 Google OTP를 다운받으세요 <br/> <br/>
				2. Google OTP 앱을 열어서 QR코드를 스캔하세요 <br/> <br/>
				3. 등록된 OTP의 인증코드 6자리를 입력하세요 <br/> <br/>
				4. 정상적으로 등록되면 OTP 인증을 2차 인증으로 사용가능합니다.
			</div>
			<div>
				<div class="text-center mt-10-m">
					<img
						v-if="qr_img"
						:src="qr_img"

						class="square-200 box"
						alt="now loading..."

					/>
				</div>

				<div class="text-center mt-30 justify-space-between">
					<input v-model="item.otp_code" class="input-box flex-1" placeholder="OTP 인증 코드" maxlength="6"/>
					<button
						class="btn-primary"
						@click="postSave"
					>등록</button>
				</div>
			</div>

		</div>


		<PopupConfirm
			v-else
			@click="onConfirm('otp')"
			:not_cancel="true"
			@cancel="$router.back()"
		>
			<template
				v-slot:title
			>본인 인증</template>
			<template
				v-slot:main-txt
			>OTP 설정을 위해 본인 인증 후 이용하세요</template>
		</PopupConfirm>
	</div>
</template>

<script>
import PopupConfirm from "../Layout/PopupConfirm";
import {Base64} from "js-base64";
export default {
	name: 'Otp'
	,
	components: {PopupConfirm},
	props: ['user']
	, data: function(){
		return {
			program: {
				name: '이차인증'
				,code: 'otp'
				,wrap: 'mypage'
				,not_top: this.$common.isMobile()
				,title: true
				,bottom: true
				,class: 'blue'
			}
			, is_on: false
			, is_on_confirm: false
			, nice_url: ''
			, nice_type: ''
			, qr_img: ''
			, item: {
				otp_code: ''
				, no: ''
				, secret: ''
			}
		}
	}
	, computed: {

	}
	, methods: {

		niceResult: function(e){
			try {
				let domains = process.env.VUE_APP_DOMAIN.split('|')
				let t = true
				for(let i = 0; i < domains.length; i++){
					if(e.origin.indexOf(domains[i]) > -1){
						t = true
					}
				}
				if(t){
					let data = e?.data
					if(data && typeof data == 'string'){
						data = JSON.parse(data)
						if(data.type == 'nice_result'){
							if(data.result){
								if(this.nice_type == 'otp'){
									this.is_on = true
									this.item.no = data.no
									this.getData()
									sessionStorage.setItem(Base64.encode('otp_pass_confirm'), Base64.encode(this.$date.getNow()))
									sessionStorage.setItem(Base64.encode('otp_pass_confirm_t'), Base64.encode(data.no))
								}
							}else{
								throw data.message
							}
						}
					}
				}
			}catch (e) {
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				// this.is_on_confirm = false
			}
		}
		, postSave: async function(){
			try {
				this.$bus.$emit('on', true)
				const result = await this.$request.init({
					method: 'post'
					, url: 'otp/postKey'
					, data: this.item
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})

					sessionStorage.removeItem(Base64.encode('otp_pass_confirm'))
					sessionStorage.removeItem(Base64.encode('otp_pass_confirm_t'))

					this.$bus.$emit('to', { name: 'MyPage', type: 'href'})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, getData: async function(){
			try {
				this.$bus.$emit('on', true)
				let url = 'otp/getKey'
				/*
				if(this.user.is_otp == '1'){
					url = 'otp/getUpdateKey'
				}
				*/
				const result = await this.$request.init({
					method: 'get'
					, url: url
					, data: {
						no: this.item.no
					}
				})

				if(result.success){
					this.qr_img = result.data.qr_code
					this.item.secret = result.data.secret
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, onConfirm: function(type){
			this.nice_type = type

			let baseUrl = this.$baseUrl

			this.nice_url = baseUrl + '/nice/request?type=' + type + '&P=' + sessionStorage.getItem(process.env.VUE_APP_NAME + 'AT')
			// this.is_on_confirm = true

			window.open(this.nice_url, 'nice', 'width=320px')
		}
	}
	, destroyed() {
		window.removeEventListener('message', this.niceResult)
	}
	, created() {
		this.$bus.$emit('onLoad', this.program)
		window.addEventListener('message', this.niceResult)

		let otp_pass_confirm = sessionStorage.getItem(Base64.encode('otp_pass_confirm'))
		if(otp_pass_confirm){

			if(this.$date.periodTime(Base64.decode(otp_pass_confirm), this.$date.getNow(), 60 * 5)){

				let otp_pass_confirm_t = sessionStorage.getItem(Base64.encode('otp_pass_confirm_t'))
				if(otp_pass_confirm_t){
					console.log(otp_pass_confirm_t)
					this.is_on = true
					this.item.no = Base64.decode(otp_pass_confirm_t)
					this.getData()
				}
			}else{
				sessionStorage.removeItem(Base64.encode('otp_pass_confirm'))
				sessionStorage.removeItem(Base64.encode('otp_pass_confirm_t'))
				this.is_on = false
			}
		}
	}
}
</script>